import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import booksAPI from '../../sources/api/booksAPI';

// constants
import { BOOK_FOLLOW } from '../../constants/booksTypes';
import { BOOK_FOLLOW_SUCCESS } from '../../constants/messages';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { bookListSchema } from '../../schemas/Normalizr';
import { toastr } from 'react-redux-toastr';

export function* bookFollow(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(BOOK_FOLLOW, call(booksAPI.follow, params), bookListSchema);
    yield toastr.success('success', BOOK_FOLLOW_SUCCESS);
  } catch (e) {
    yield toastr.error(e.response.body.message);
    yield put(error(BOOK_FOLLOW, e));
  } finally {
    yield put(doneIndicator(BOOK_FOLLOW));
  }
}

export function* watchBookFollow() {
  yield takeEvery(BOOK_FOLLOW, bookFollow);
}

export default function* root() {
  yield all([
    fork(watchBookFollow)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/bookFollow.js